<template>
  <!--  main div  -->
  <div class="d-flex flex-column mt-2 justify-content-start" style="height: 100%">
    <!--  top div  -->
    <!--  body div  -->
    <v-card class="d-flex flex-column " style="height: 100%;">
      <v-card-title class="no-print">Results</v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 100%; overflow-x: auto">
        <div id="doc-main" class="d-flex flex-column flex-lg-row-reverse justify-space-between"
             style="height: 100%; min-width: 210mm">
          <div
            class="d-flex flex-row flex-lg-column justify-start d-lg-block flex-shrink-1 mb-md-6 mx-lg-auto px-lg-2 no-print"
            id="actions">
            <x-select
              :class="{'mr-2 mb-2': true, 'ml-2': isLarge}"
              :items="sessions"
              v-model="selectedSession"
              return-object
              item-text="name"
              outlined
              dense
              placeholder="Session">
            </x-select>

            <x-select
              :class="{'mx-2 mb-2': true}"
              :items="semesters"
              v-model="selectedSemester"
              return-object
              item-text="title"
              outlined
              dense
              placeholder="Semester">
            </x-select>

            <x-button
              :class="{'mx-2': true, 'mr-2': isMobile}"
              color="primary"
              :width="isLarge ? '95%' : '20%'" :disabled="disablePrinting"
              @click="printDoc">
              Print
            </x-button>
            <v-spacer v-if="isLarge"></v-spacer>
          </div>
          <div v-if="results.length === 0" class="flex-grow-1 text-md-center text-lg-left">
            <v-alert type="info" rounded :class="{'mr-2': isMobile}">No results to show</v-alert>
          </div>
          <div v-else class="mx-md-auto pl-lg-4">
            <v-sheet id="doc" elevation="2" class="pa-4 d-flex flex-column" style="width: 210mm /* size of A4 paper */">
              <div>
                <div class="d-flex flex-row justify-space-between">
                  <!--   text     -->
                  <div class="my-auto mx-auto">
                    <div class="text-center text-h5 font-weight-bold mb-3 success--text">NASARAWA STATE UNIVERSITY,
                      KEFFI
                    </div>
                    <div class="text-center font-weight-bold">Student's Result</div>
                  </div>
                </div>

                <v-sheet outlined rounded class="mt-8 mx-auto">
                  <v-simple-table dense>
                    <tbody>
                    <tr>
                      <th style="width: 15%">Name</th>
                      <td style="width: 35%">{{ getUser.name }}</td>
                      <th style="width: 15%">Matric:</th>
                      <td style="width: 30%">{{ getUser.userId }}</td>
                    </tr>
                    <tr>
                      <th style="width: 15%">Faculty</th>
                      <td style="width: 35%" class="text-left">{{ getUser.programme.department.faculty.name }}</td>
                      <th style="width: 15%">Department:</th>
                      <td style="width: 30%">{{ getUser.programme.department.name }}</td>
                    </tr>
                    <tr>
                      <th style="width: 15%">Programme</th>
                      <td style="width: 35%" class="text-left">{{ getUser.programme.name }}</td>
                      <th style="width: 15%">Level</th>
                      <td style="width: 30%">{{
                          (resultData != null && resultData.level != null) ? (resultData?.level?.title || '') : getUser.level.title
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th style="width: 15%">Session</th>
                      <td style="width: 35%" class="text-left">
                        {{ selectedSession != null ? selectedSession.name : '' }}
                      </td>
                      <th style="width: 15%">Semester:</th>
                      <td style="width: 30%">{{ selectedSemester != null ? selectedSemester.title : '' }}</td>
                    </tr>
                    </tbody>
                  </v-simple-table>
                </v-sheet>

                <v-sheet outlined rounded class="mx-auto mt-8">
                  <v-simple-table dense>
                    <thead>
                    <tr>
                      <th>Course code</th>
                      <th>Unit</th>
                      <th>CA</th>
                      <th>Exam</th>
                      <th>Total</th>
                      <th class="text-right">Grade</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in results" :key="index"
                        :style="{color: item.registeredCourse.passed ? 'black' : 'red'}">
                      <td style="font-size: 0.8em" class="font-weight-bold">{{ item.course.courseCode }}</td>
                      <td style="font-size: 0.8em" class=" ">{{ item.course.creditUnit }}</td>
                      <td style="font-size: 0.8em" class=" ">{{ ((item.ca <= 0.0 || item.ca <= 0) && (!item.ca2 || item.ca2 <= 0.0)) ? "-" : `${item.ca}, ${item.ca2 || '-'}` }}</td>
                      <td style="font-size: 0.8em" class=" ">
                        {{ (item.exam <= 0.0 || item.exam < 0) ? "-" : item.exam }}
                      </td>
                      <td style="font-size: 0.8em" class="">{{ item.total }}</td>
                      <td style="font-size: 0.8em" class="text-right">
                        <pre>{{ item.grade + '   ' }}</pre>
                      </td>
                    </tr>
                    </tbody>
                  </v-simple-table>
                </v-sheet>

                <!-- data -->
                <template v-if="resultData && resultData.data">
                  <!-- remarks -->
                  <template v-if="resultData.data.remarks.rep || resultData.data.remarks.reg">
                    <div class="error--text mt-8">Remarks</div>
                    <v-sheet elevation="0" rounded outlined class="mx-auto ">
                      <v-simple-table dense>
                        <tbody>
                        <tr style="border-radius: 7px;" v-if="resultData.data.remarks.rep">
                          <td style="font-size: 0.8em; color: #ff00a6" class=" ">{{ resultData.data.remarks.rep }}</td>
                        </tr>
                        <tr style="border-radius: 7px;" v-if="resultData.data.remarks.reg">
                          <td style="font-size: 0.8em; color: red" class=" ">{{ resultData.data.remarks.reg }}</td>
                        </tr>
                        </tbody>
                      </v-simple-table>
                    </v-sheet>
                  </template>

                  <!-- summary -->
                  <template v-if="resultData.data.previous">
                    <!--<div class="primary&#45;&#45;text mt-8">Summary</div>-->
                    <v-sheet elevation="0" rounded outlined class="mx-auto ">
                      <v-simple-table dense>
                        <thead>
                        <tr>
                          <th>Previous CGPA</th>
                          <th>TCE</th>
                          <th>TCR</th>
                          <th>TGP</th>
                          <th>GPA</th>
                          <th>Current. CGPA</th>
                          <th class="text-right">Difference</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr style="border-radius: 7px;">
                          <td style="font-size: 0.8em" class="font-weight-bold">
                            {{ resultData.data.previous.cgpa }}
                          </td>
                          <td style="font-size: 0.8em" class=" ">{{ resultData.data.current.tce }}</td>
                          <td style="font-size: 0.8em" class=" ">{{ resultData.data.current.tcr }}</td>
                          <td style="font-size: 0.8em" class="">{{ resultData.data.current.tgp }}</td>
                          <td style="font-size: 0.8em" class=" ">{{ resultData.data.current.gpa }}</td>
                          <td style="font-size: 0.8em" class=" ">{{ resultData.data.current.cgpa }}</td>
                          <td style="font-size: 0.8em" class="text-right">{{
                              resultData.percentageDiff.toFixed(2)
                            }}
                          </td>
                        </tr>
                        </tbody>
                      </v-simple-table>
                    </v-sheet>

                    <div class="primary--text mt-4" style="text-decoration: underline">Comment</div>
                    <div class="font-weight-bold success--text" v-if="resultData.progressed">{{
                        resultData.comment
                      }}
                    </div>
                    <div class="font-weight-bold error--text" v-else>{{ resultData.comment }}</div>
                    <!--<div class="primary&#45;&#45;text mt-4">Prediction of next result</div>-->
                    <div class="font-weight-bold">{{ resultData.prediction }}</div>
                  </template>

                  <template v-else-if="resultData.data.current">
                    <!--<div class="primary&#45;&#45;text mt-8">Summary for current semester</div>-->
                    <v-sheet elevation="0" rounded outlined class="mx-auto ">
                      <v-simple-table dense>
                        <thead>
                        <tr>
                          <th>TCE</th>
                          <th>TCR</th>
                          <th class="">TGP</th>
                          <th class="">GPA</th>
                          <th class="text-right">CGPA</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr style="border-radius: 7px;">
                          <td style="font-size: 0.8em" class=" ">{{ resultData.data.current.tce }}</td>
                          <td style="font-size: 0.8em" class=" ">{{ resultData.data.current.tcr }}</td>
                          <td style="font-size: 0.8em" class="">{{ resultData.data.current.tgp }}</td>
                          <td style="font-size: 0.8em" class=" ">{{ resultData.data.current.gpa }}</td>
                          <td style="font-size: 0.8em" class="font-weight-bold text-right">
                            {{ resultData.data.current.cgpa }}
                          </td>
                        </tr>
                        </tbody>
                      </v-simple-table>
                    </v-sheet>
                  </template>
                </template>
              </div>
              <v-spacer></v-spacer>
              <div class="d-flex flex-row justify-space-between mb-12">
                <!--<div><span class="subtitle-2 font-weight-bold">GPA: </span>{{gp.toFixed(2)}}</div>-->
                <!--<div class="mt-auto"><span class="subtitle-2 font-weight-bold">CGPA: </span>{{cgpa.toFixed(2)}}</div>-->
              </div>

            </v-sheet>
          </div>
          <loading-dialog :show="loading"></loading-dialog>
          <message-box :show="messageShow" :message="message" :type="messageType"
                       v-on:close-message="messageShow = !messageShow"></message-box>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>


<script>
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import {mapGetters} from "vuex";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import XSelect from "@ui/widgets/XSelect.vue";
import XButton from "@ui/widgets/XButton.vue";

export default {
  name: "ResultsPage",
  components: {XButton, XSelect, MessageBox, LoadingDialog},

  data: () => ({
    results: [],
    messageType: '',
    message: '',
    messageShow: false,
    loading: false,
    semesters: [],
    sessions: [],
    selectedSemester: null,
    selectedSession: null,
    resultData: null,
    gp: 0,
    cgpa: 0,
  }),

  methods: {
    loadResults() {
      if (this.selectedSemester != null && this.selectedSession != null) {
        this.loading = true;
        let uId = this.getUser.userId
        let session = this.selectedSession.id
        let semester = this.selectedSemester.id
        Api.results.forStudent(uId, session, semester)
          .then(res => {
            this.results = res.data.results
            this.resultData = res.data
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
      }
    },

    loadSessions() {
      if (this.getUser != null) {
        this.selectedSession = null
        this.loading = true
        Api.session.getFullPaidSessionsForStudent(this.getUser.userId)
          .then(res => this.sessions = res.data)
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
      }
    },

    printDoc() {
      window.print();
    },
  },

  computed: {
    ...mapGetters(['getUser', 'getCurrentSession']),
    disablePrinting: function () {
      return this.selectedSemester == null || this.selectedSession == null || this.results.length < 1
    },

    isMediumAndUp: function () {
      return this.$vuetify.breakpoint.mdAndUp
    },

    isLarge: function () {
      return this.$vuetify.breakpoint.lgAndUp
    },

    isMedium: function () {
      return this.$vuetify.breakpoint.mdOnly
    },

    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown
    },
  },

  watch: {
    selectedSession: function (newVal) {
      this.semesters = []
      this.selectedSemester = null
      if (newVal != null) {
        this.semesters = newVal.semesters
        // this.loadResults()
      }
    },

    selectedSemester: function () {
      this.loadResults()
    },

    getUser: function (newVal) {
      if (newVal != null) {
        this.loadSessions()
      }
    }
  },

  created() {
    this.loadSessions()
  }
}
</script>

<style scoped>
@media print {
  #doc {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
  }

  .no-print {
    display: none;
  }

  #actions {
    display: none;
  }

  @page {
    margin: 0;
    size: A4;
  }
}

.v-sheet {
  transition: all 0.3s ease-in-out;
}

.v-sheet:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}
</style>
